import { render, staticRenderFns } from "./StackedModalRoot.vue?vue&type=template&id=6d98e236&scoped=true"
import script from "./StackedModalRoot.vue?vue&type=script&lang=js"
export * from "./StackedModalRoot.vue?vue&type=script&lang=js"
import style0 from "./StackedModalRoot.vue?vue&type=style&index=0&id=6d98e236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d98e236",
  null
  
)

export default component.exports